module.exports = __webpack_public_path__ + "static/media/download-attachment.9eb1188a.svg";